"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    d: "m13.9626 5.9347.216-.9308h2.0581l-.3306 1.4029a2.9994 2.9994 0 0 0 .1047 1.7574l.5275 1.413a4.9999 4.9999 0 0 1 .1527 3.0153c-.0772.2949-.1937.5983-.1937.9063h-2c0-.2695.0295-.5365.0978-.7976.214-.8172.3786-1.5965.0695-2.4244l-.5275-1.413a5 5 0 0 1-.1745-2.9291zm6.0347 7.5641h-2c0-.2762.0277-.5493.0978-.8171.214-.8173.3786-1.5965.0695-2.4245l-.5275-1.413a5 5 0 0 1-.1745-2.929l.2112-.9113h2.0582l-.3259 1.3834a2.9994 2.9994 0 0 0 .1047 1.7574l.5275 1.413a5 5 0 0 1 .1527 3.0153c-.0793.3028-.1937.6097-.1937.9258zm-3.4977 1.5017h-2v3h2v-3zm3.5 0h-2v3h2v-3zM13 15H3v3h10v-3z"
  })];
};

exports.default = _default;